import { t } from 'i18next';
import type { CommentableContentObject, Reply } from 'models';
import type { RefObject } from 'react';
import { Button, Card, Icon, type InputRef, type RichTextEditorBase, type RichTextMentions } from 'ui';
import type { CommentMode } from '../../create-comment-form';
import { Comments } from '../comments';

type P = {
  canComment: boolean;
  canDeleteComment: (comment: Reply) => boolean;
  commentFormContainerRef: RefObject<HTMLDivElement | null>;
  comments: Reply[];
  contentObjectId: string;
  contentObjectType: CommentableContentObject['type'];
  editorRef: RefObject<null | RichTextEditorBase>;
  initialMode?: CommentMode;
  inputRef: RefObject<InputRef | null>;
  onRequestMentions: RichTextMentions;
};

const CommentsCard = ({
  canComment,
  canDeleteComment,
  commentFormContainerRef,
  comments,
  contentObjectId,
  contentObjectType,
  editorRef,
  initialMode,
  inputRef,
  onRequestMentions,
}: P) => (
  <Card
    extra={
      canComment ? (
        <Button
          onClick={() => {
            editorRef.current?.focus() ?? inputRef.current?.focus({ preventScroll: true });
            requestAnimationFrame(() => {
              commentFormContainerRef.current?.scrollIntoView({ behavior: 'smooth' });
            });
          }}
          type="link-primary"
        >
          Add comment
        </Button>
      ) : null
    }
    title={<Card.Title icon={<Icon icon="chat-3-line" />}>{t('comments', { count: comments.length })}</Card.Title>}
  >
    <Comments
      canComment={canComment}
      canDeleteComment={canDeleteComment}
      commentFormContainerRef={commentFormContainerRef}
      comments={comments}
      contentObjectId={contentObjectId}
      contentObjectType={contentObjectType}
      editorRef={editorRef}
      initialMode={initialMode}
      inputRef={inputRef}
      onRequestMentions={onRequestMentions}
    />
  </Card>
);

export default CommentsCard;
